import Vue from 'vue';
import Vuex from 'vuex';
import state from '@/assets/common/store/state.js';
import getters from '@/assets/common/store/getters.js';
import actions from '@/assets/common/store/actions.js';
import mutations from '@/assets/common/store/mutations.js';

Vue.use(Vuex);
Vue.prototype.$storeClone = JSON.parse(JSON.stringify(state));
const store = new Vuex.Store({
    state,
    mutations,
    getters,
    actions
})

export default store;